"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyLogo = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const shared_1 = require("../../../shared");
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const LegacyPropertyLogoLink_1 = require("./LegacyPropertyLogoLink");
const SwappablePropertyLogoLink_1 = require("./SwappablePropertyLogoLink");
const styles = (0, styled_components_1.css) `
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    opacity: 0.92;
    height: ${(p) => p.theme.navHeight}px;
    opacity: 1;
    transition: opacity 0.4s ease-in-out;
    width: ${(p) => (p.theme.logo.width ? `${p.theme.logo.width}px` : 'auto')};
    margin: ${(p) => p.theme.logo.margin || '0 24px 0 12px'};
    align-items: center;

    && {
        display: flex;
        padding: 0;
    }

    &:hover {
        opacity: 1;
        transition: 0.2s opacity ease-in;
    }

    &:focus {
        outline-offset: -2px;
    }

    &.src {
        background-image: url(${(p) => p.theme.logo.src});
    }

    ${(p) => p.theme.breakpoints.down('sm')} {
        margin-right: 0;
        margin-left: 0;
    }
`;
exports.PropertyLogo = (0, styled_components_1.default)(({ logoLink = {}, locale, className }) => {
    var _a, _b;
    const { messages } = (0, shared_1.useMessages)();
    const { mobile } = (0, epic_games_nav_shared_1.useMode)();
    const theme = (0, epic_games_nav_shared_1.useTheme)();
    const useNode = !!((_a = theme === null || theme === void 0 ? void 0 : theme.logo) === null || _a === void 0 ? void 0 : _a.node);
    const logoOnlyDownSm = (logoLink === null || logoLink === void 0 ? void 0 : logoLink.logoOnlyDownSm) || false;
    const hidden = logoOnlyDownSm && !mobile;
    if (hidden) {
        return react_1.default.createElement("div", { id: "propLogo" });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Link, { link: logoLink, locale: locale, role: "button", "aria-label": messages.propLogoLabel, id: "propLogo", className: `propLogo ${!useNode && 'src'} ${className}`, onMouseDown: epic_games_nav_shared_1.stopFocusOnClick }, useNode && ((_b = theme === null || theme === void 0 ? void 0 : theme.logo) === null || _b === void 0 ? void 0 : _b.node))));
}) `
    ${styles}
`;
function Link(_a) {
    var { link } = _a, props = __rest(_a, ["link"]);
    const isLegacyLinkBehaviour = (0, epic_games_nav_shared_1.useLegacyLinkBehaviour)();
    if (isLegacyLinkBehaviour) {
        return react_1.default.createElement(LegacyPropertyLogoLink_1.LegacyPropertyLogoLink, Object.assign({ logoLink: link }, props));
    }
    return react_1.default.createElement(SwappablePropertyLogoLink_1.SwappablePropertyLogoLink, Object.assign({ link: link }, props));
}
//# sourceMappingURL=Logo.js.map